/* Vinciguerra Sartoria Italiana — behaviour that Smootify used to provide.
   Webflow's own bundle still owns nav, dropdowns, lightbox and IX2 animations. */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    var withPoint = value;
    var grouped = function (s, thousands, decimal) {
      var parts = s.split(decimal);
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, grouped(withComma, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, grouped(withComma.split(',')[0], '.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, grouped(withPoint.split('.')[0], ',', '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, grouped(withPoint, ',', '.'));
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (r) {
      if (!r.ok) throw new Error(r.statusText);
      return r.json();
    });
  }

  /* ---------------------------------------------------------------- cart */

  var CartDrawer = {
    el: null,

    init: function () {
      this.el = document.querySelector('cart-drawer');
      if (!this.el) return;

      var self = this;
      document.addEventListener('click', function (e) {
        var open = e.target.closest('cart-drawer [data-trigger="open"]');
        if (open) { self.isOpen() ? self.close() : self.open(); return; }

        var close = e.target.closest('cart-drawer [data-trigger="close"]');
        if (close) { e.preventDefault(); self.close(); return; }

        var remove = e.target.closest('cart-drawer [data-action="remove"]');
        if (remove) { e.preventDefault(); self.setQuantity(remove.closest('cart-item'), 0); return; }

        var step = e.target.closest('cart-drawer [data-action="plus"], cart-drawer [data-action="minus"]');
        if (step) {
          e.preventDefault();
          var item = step.closest('cart-item');
          var input = item.querySelector('.sm-quantity-field');
          var next = parseInt(input.value, 10) + (step.dataset.action === 'plus' ? 1 : -1);
          self.setQuantity(item, Math.max(0, next));
        }
      });

      this.el.addEventListener('change', function (e) {
        if (!e.target.matches('.sm-quantity-field')) return;
        self.setQuantity(e.target.closest('cart-item'), Math.max(0, parseInt(e.target.value, 10) || 0));
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });
    },

    container: function () {
      return this.el.querySelector('.sm-ix-cart_interaction-container');
    },

    isOpen: function () {
      return this.container().classList.contains('is-open');
    },

    /* `is-visible` flips display, then a frame later `is-open` runs the slide —
       a transition cannot start on the same frame as `display: none` -> flex.
       The timeout backs up rAF, which never fires while the tab is hidden. */
    open: function () {
      var container = this.container();
      container.classList.add('is-visible');
      var reveal = function () { container.classList.add('is-open'); };
      requestAnimationFrame(function () { requestAnimationFrame(reveal); });
      setTimeout(reveal, 50);
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      var container = this.container();
      container.classList.remove('is-open');
      document.body.style.overflow = '';
      var done = function (e) {
        if (e && e.target !== container.querySelector('.sm-ix-cart_form-block')) return;
        container.classList.remove('is-visible');
        container.removeEventListener('transitionend', done);
      };
      container.addEventListener('transitionend', done);
      setTimeout(done, 500);
    },

    setQuantity: function (item, quantity) {
      if (!item) return;
      var self = this;
      item.style.opacity = '0.5';
      fetchJSON(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.dataset.key, quantity: quantity })
      })
        .then(function () { return self.refresh(); })
        .catch(function () { item.style.opacity = ''; });
    },

    /* Re-render from the server so drawer markup and Liquid stay the single source. */
    refresh: function () {
      var self = this;
      return fetch(routes.root + '?section_id=cart-drawer-fragment')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          if (!fresh) return;
          self.el.querySelector('.sm-ix-cart_relative-container').innerHTML =
            fresh.querySelector('.sm-ix-cart_relative-container').innerHTML;
          self.el.querySelector('[cart="count"]').textContent =
            fresh.querySelector('[cart="count"]').textContent;
          document.dispatchEvent(new CustomEvent('cart:updated'));
        });
    },

    add: function (formData) {
      var self = this;
      return fetchJSON(routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      }).then(function (item) {
        return self.refresh().then(function () {
          self.open();
          return item;
        });
      });
    }
  };

  /* --------------------------------------------------- add-to-cart forms */

  function bindProductForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();

      var button = form.querySelector('[data-add-to-cart]');
      var buyNow = form.dataset.pendingBuyNow === 'true';
      form.dataset.pendingBuyNow = 'false';

      setLoading(button, true);
      CartDrawer.add(new FormData(form))
        .then(function () {
          setLoading(button, false);
          if (buyNow) window.location.href = routes.cart + '?checkout=1';
        })
        .catch(function () {
          setLoading(button, false);
          form.submit();
        });
    });

    document.addEventListener('click', function (e) {
      var buyNow = e.target.closest('[data-buy-now]');
      if (!buyNow) return;
      var form = buyNow.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      form.dataset.pendingBuyNow = 'true';
      setLoading(buyNow, true);
      CartDrawer.add(new FormData(form))
        .then(function () { window.location.href = routes.cart; })
        .catch(function () { setLoading(buyNow, false); });
    });
  }

  function setLoading(button, loading) {
    if (!button) return;
    var dflt = button.querySelector('.default-state');
    var busy = button.querySelector('.loading-state');
    if (dflt) dflt.classList.toggle('is-hidden', loading);
    if (busy) busy.classList.toggle('is-hidden', !loading);
    button.disabled = loading;
  }

  /* ------------------------------------------------- standalone quantity */

  function bindQuantityInputs() {
    document.addEventListener('click', function (e) {
      var step = e.target.closest('quantity-input:not(cart-drawer quantity-input) [data-action="plus"], quantity-input:not(cart-drawer quantity-input) [data-action="minus"]');
      if (!step) return;
      e.preventDefault();
      var input = step.closest('quantity-input').querySelector('input');
      var min = parseInt(input.min, 10) || 1;
      var next = (parseInt(input.value, 10) || min) + (step.dataset.action === 'plus' ? 1 : -1);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------------------------------ wishlist */

  var Wishlist = {
    key: 'vinciguerra:wishlist',

    read: function () {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; }
      catch (e) { return []; }
    },

    write: function (ids) {
      localStorage.setItem(this.key, JSON.stringify(ids));
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { ids: ids } }));
    },

    has: function (id) { return this.read().indexOf(String(id)) !== -1; },

    toggle: function (id) {
      var ids = this.read();
      var i = ids.indexOf(String(id));
      if (i === -1) ids.push(String(id)); else ids.splice(i, 1);
      this.write(ids);
      return i === -1;
    },

    init: function () {
      var self = this;
      this.paint();

      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('wishlist-toggle[data-product-handle]');
        if (!toggle) return;
        e.preventDefault();
        e.stopPropagation();
        var active = self.toggle(toggle.dataset.productHandle);
        toggle.classList.toggle('is-in-wishlist', active);
      });

      document.addEventListener('wishlist:updated', function () { self.paint(); });
      document.addEventListener('cart:updated', function () { self.paint(); });
    },

    paint: function () {
      var ids = this.read();
      document.querySelectorAll('wishlist-toggle[data-product-handle]').forEach(function (el) {
        el.classList.toggle('is-in-wishlist', ids.indexOf(el.dataset.productHandle) !== -1);
      });

      // Il badge nell'header: nascosto a zero, come farebbe il carrello vuoto.
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = ids.length;
        el.hidden = ids.length === 0;
      });

      var page = document.querySelector('[data-wishlist-grid]');
      if (!page) return;
      var empty = document.querySelector('[data-wishlist-empty]');
      var shown = 0;
      page.querySelectorAll('[data-product-card]').forEach(function (card) {
        var keep = ids.indexOf(card.dataset.productCard) !== -1;
        card.style.display = keep ? '' : 'none';
        if (keep) shown++;
      });
      if (empty) empty.style.display = shown ? 'none' : '';
    }
  };

  /* ------------------------------------------------- product page images */

  function bindVariants() {
    document.addEventListener('click', function (e) {
      var button = e.target.closest('variant-swatches .sm-variant-button');
      if (!button || button.classList.contains('is-disabled')) return;
      e.preventDefault();

      var root = button.closest('[data-variant-root]');
      var group = button.closest('variant-swatches');
      group.querySelectorAll('.sm-variant-button').forEach(function (b) {
        b.classList.toggle('is-active', b === button);
      });
      var selected = group.querySelector('.sm-variant__selected-option');
      if (selected) selected.textContent = button.dataset.value;

      selectVariant(root);
    });
  }

  function selectVariant(root) {
    if (!root) return;
    var variants = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var chosen = Array.prototype.map.call(
      root.querySelectorAll('variant-swatches'),
      function (g) {
        var active = g.querySelector('.sm-variant-button.is-active');
        return active ? active.dataset.value : null;
      }
    );

    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });

    var input = root.querySelector('[name="id"]');
    var price = root.querySelector('[data-prop="price"]');
    var compare = root.querySelector('[data-prop="compareAtPrice"]');
    var button = root.querySelector('[data-add-to-cart]');

    if (!match) {
      if (button) { button.disabled = true; }
      return;
    }

    input.value = match.id;
    if (price) price.textContent = money(match.price);
    if (compare) {
      compare.textContent = match.compare_at_price ? money(match.compare_at_price) : '';
      compare.style.display = match.compare_at_price ? '' : 'none';
    }
    if (button) {
      button.disabled = !match.available;
      var label = button.querySelector('.sm-buy-button__text');
      if (label && !match.available) label.textContent = window.theme.strings.soldOut;
    }

    root.querySelectorAll('[data-stock-state]').forEach(function (el) {
      el.style.display = el.dataset.stockState === stockState(match) ? '' : 'none';
    });

    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
  }

  function stockState(variant) {
    if (!variant.available) return 'out';
    if (variant.inventory_management === null) return 'in';
    if (variant.inventory_quantity === 1) return 'last';
    if (variant.inventory_quantity <= 5) return 'low';
    return 'in';
  }

  /* ------------------------------------------------------------ cart page */

  function bindCartPage() {
    var page = document.querySelector('cart-page');
    if (!page) return;

    page.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-action="remove"]');
      if (remove) {
        e.preventDefault();
        updateLine(remove.closest('cart-item'), 0);
        return;
      }

      var step = e.target.closest('[data-action="plus"], [data-action="minus"]');
      if (step) {
        e.preventDefault();
        var item = step.closest('cart-item');
        var input = item.querySelector('.sm-quantity-field');
        var next = parseInt(input.value, 10) + (step.dataset.action === 'plus' ? 1 : -1);
        updateLine(item, Math.max(0, next));
        return;
      }

      /* Shopify only accepts discount codes at checkout; /discount/CODE
         stores it on the session and comes straight back to the cart. */
      var coupon = e.target.closest('[data-action="coupon"]');
      if (coupon) {
        e.preventDefault();
        var field = page.querySelector('[data-discount-code]');
        var code = field.value.trim();
        if (code) {
          window.location.href = routes.root + 'discount/' + encodeURIComponent(code) +
            '?redirect=' + encodeURIComponent(routes.cart);
        }
      }
    });

    page.addEventListener('change', function (e) {
      if (!e.target.matches('.sm-quantity-field')) return;
      updateLine(e.target.closest('cart-item'), Math.max(0, parseInt(e.target.value, 10) || 0));
    });

    /* Persist the note without making the customer submit the form. */
    var note = page.querySelector('[name="note"]');
    if (note) {
      note.addEventListener('change', function () {
        fetch(routes.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });
    }

    function updateLine(item, quantity) {
      if (!item) return;
      item.style.opacity = '0.5';
      fetchJSON(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.dataset.key, quantity: quantity })
      })
        .then(function () { window.location.reload(); })
        .catch(function () { item.style.opacity = ''; });
    }
  }

  /* -------------------------------------------------------- collection UI */

  function bindCollection() {
    var grid = document.querySelector('collection-grid, search-results');
    if (!grid) return;

    grid.addEventListener('change', function (e) {
      if (e.target.matches('[data-auto-submit]')) {
        submitFilters(grid);
      }
    });

    grid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-search-redirect]')) {
        e.preventDefault();
        var term = e.target.value.trim();
        window.location.href = term
          ? routes.search + '?q=' + encodeURIComponent(term) + '&type=product'
          : window.location.pathname;
      }
    });

    grid.addEventListener('click', function (e) {
      if (e.target.closest('[data-action="close"]')) {
        var details = e.target.closest('details');
        if (details) details.open = false;
        return;
      }

      var more = e.target.closest('[data-action="load"]');
      if (!more) return;
      e.preventDefault();
      more.textContent = '…';
      fetch(more.href)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('[data-products-grid] > *');
          var target = grid.querySelector('[data-products-grid]');
          cards.forEach(function (c) { target.appendChild(c); });

          var nextButton = doc.querySelector('[data-action="load"]');
          var pagination = more.closest('.sm-search_pagination');
          if (nextButton) {
            more.href = nextButton.getAttribute('href');
            more.textContent = nextButton.textContent;
          } else {
            pagination.remove();
          }
          Wishlist.paint();
        });
    });
  }

  function submitFilters(grid) {
    var form = grid.querySelector('#CollectionFilters');
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (key !== 'q' && String(value).length) params.append(key, value);
    });
    var query = params.toString();
    window.location.href = window.location.pathname + (query ? '?' + query : '');
  }

  /* ------------------------------------------------- product recommendations */

  function bindRecommendations() {
    var holder = document.querySelector('[data-recommendations]');
    if (!holder) return;
    fetch(holder.dataset.recommendations)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (!fresh || !fresh.querySelector('product-card')) {
          /* Nothing to recommend — drop the heading too. */
          var heading = holder.previousElementSibling;
          if (heading && heading.querySelector('h2')) heading.remove();
          holder.remove();
          return;
        }
        holder.innerHTML = fresh.innerHTML;
        Wishlist.paint();
      });
  }

  /* ---------------------------------------------------- cookie prefs link */

  function bindPreferences() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-is="preferences-button"]')) return;
      e.preventDefault();
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.showPreferences();
      }
    });
  }

  function init() {
    CartDrawer.init();
    bindProductForms();
    bindQuantityInputs();
    bindVariants();
    bindCartPage();
    bindCollection();
    bindRecommendations();
    bindPreferences();
    Wishlist.init();
    window.theme.cart = CartDrawer;
    window.theme.wishlist = Wishlist;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
